import { AnyVoidFn as AnyVoidFunction, PromiseFn as PromiseFunction } from '../types/common'
import { ICXF } from '../types/cxf'

const startTimer = (function_: AnyVoidFunction, time: number) => {
    const id = setTimeout(function_, time)
    return () => clearTimeout(id)
}

const timeout =
    <A, B>(function_: PromiseFunction<A, B>, time: number): PromiseFunction<A, B> =>
    (a) => {
        return new Promise((resolve, reject) => {
            const stopTimer = startTimer(() => {
                reject(new Error(`Timeout has exceeded ${time}`))
            }, time)

            function_(a)
                .then((value) => {
                    resolve(value)
                    stopTimer()
                })
                .catch(reject)
        })
    }

export const loadScript = (src: string) =>
    new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.type = 'text/javascript'
        script.type = 'module'
        script.async = true
        script.src = src
        script.addEventListener('load', resolve)
        // script.onerror = reject
        script.addEventListener('error', reject)
        document.body.append(script)
    })

// eslint-disable-next-line @typescript-eslint/no-var-requires
export const loadCxf = timeout(() => require('@goodgamestudios/cxf-ready') as Promise<ICXF>, 10_000)
